import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 80, height = 80, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg' class={customClass}>
  <path d='M64.5 33.4667C62.2333 21.9667 52.1333 13.3333 40 13.3333C30.3667 13.3333 22 18.8 17.8333 26.8C7.8 27.8667 0 36.3667 0 46.6667C0 57.7 8.96667 66.6667 20 66.6667H63.3333C72.5333 66.6667 80 59.2 80 50C80 41.2 73.1667 34.0667 64.5 33.4667ZM46.6667 43.3333V56.6667H33.3333V43.3333H23.3333L40 26.6667L56.6667 43.3333H46.6667Z' fill={color} />
</svg>
